export const selectBoard = store => store.gamesValuesStore.board;
export const selectBalance = store => store.gamesValuesStore.balance;
export const selectMultiplier = store => store.gamesValuesStore.multiplier;
export const selectGameOver = store => store.gamesValuesStore.gameOver;
export const selectOpenedCells = store => store.gamesValuesStore.openedCells;
export const selectClaimBalance = store => store.gamesValuesStore.claimBalance;
export const selectBombIsOpen = store => store.gamesValuesStore.bombIsOpen;
export const selectToClaim = store => store.gamesValuesStore.toClaim;


